module.exports = __webpack_public_path__ + "img/scicon.c40300c1.png";